import React from "react";
import { HiDotsVertical } from "react-icons/hi";
import ProgressData from "../components/card/ProgressData";
import CreditScore from "../components/chart/CreditScore";
import Tab from "../components/Tab/Tab";

function YourProgress() {
  const disputes = [
    { name: "Experian", count: 10 },
    { name: "Equifax", count: 10 },
    { name: "TransUnion", count: 10 },
  ];

  // Calculate the total
  const totalDisputes = disputes.reduce((total, item) => total + item.count, 0);

  return (
    <div className="page_overflow">
      <section className="progress_page">
        <div className="container">
          <div className="section_title">
            <h1>Your Progress</h1>
          </div>
          <div className="row">
            <div className="col-lg-6">
              <ProgressData />
            </div>
            <div className="col-lg-6">
              <div className="card chart-box">
                <div className="header_area">
                  <h3>Your Credit Score</h3>
                  <HiDotsVertical className="icons dot-icon" />
                </div>
                <CreditScore />
              </div>
            </div>
            <div className="col-lg-4">
              <div className="card">
                <div className="header_area">
                  <h3>Dispute Deletions</h3>
                  <HiDotsVertical className="icons dot-icon" />
                </div>
                <ul className="dispute_list">
                  {disputes.map((dispute, index) => (
                    <li key={index}>
                      <h4>{dispute.name}</h4>
                      <h2>{dispute.count}</h2>
                    </li>
                  ))}
                </ul>
                <ul className="total">
                  <li>
                    <h3>Total:</h3>
                    <h1>{totalDisputes}</h1>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-8">
              <div className="card">
                <div className="header_area">
                  <h3>Total Utilization</h3>
                  <HiDotsVertical className="icons dot-icon" />
                </div>
                <Tab />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default YourProgress;
